import { Constants } from '@chegg/optimizely-sdk'
import { UserAttributes } from '@optimizely/optimizely-sdk'
import { OptimizelyProvider } from '@optimizely/react-sdk'
import { UserRoles } from '@src/constants/user'
import { getUserRole } from '@src/state/auth/selectors'
import { TEST_AUDIENCE } from '@src/state/optimizely/constants'
import optimizely from '@src/state/optimizely/optimizely'
import { getQueryParams } from '@src/state/router/selectors'
import { getCookieDomain } from '@src/state/site/selectors'
import { default as wtSiteName } from '@src/state/site/site'
import { Cookies, getCookie, setCookie } from '@src/utils/cookies'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { getOrSetVCookie } from '../../utils/vCookie'

interface UserInfo {
  id: string
  attributes?: UserAttributes
}

declare global {
  interface Window {
    /**
     * One of the properties added to the window by short-circuit-viewer-location.js
     *
     * Represents the country code of the country that the user is visiting our site from
     */
    __sbmCountryCode?: string
  }
}

const OptProvider: React.FunctionComponent = ({ children }) => {
  if (!optimizely) {
    return <>{children}</>
  }

  const storeUserRole = useSelector(getUserRole)
  const queryParams = useSelector(getQueryParams)
  const cookieUserRole = getCookie(Cookies.UserRole)
  const wtUserRole = storeUserRole || cookieUserRole || UserRoles.NOT_LOGGED_IN

  const wtFromSEM = getCookie(Cookies.FromSEM) === 'true' ? true : false
  const wtFromAffiliate = getCookie(Cookies.FromAffiliate) === 'true' ? true : false

  let wtTestAudience = false
  if (queryParams[TEST_AUDIENCE] !== undefined) {
    wtTestAudience = true
    setCookie(Cookies.OptimizelyTestCookie, 'true', { expires: 1 })
  } else if (getCookie(Cookies.OptimizelyTestCookie) === 'true') {
    wtTestAudience = true
  }

  const user: UserInfo = {
    id: getOrSetVCookie(getCookieDomain(wtSiteName)),
    attributes: {
      wtSiteName,
      wtUserRole,
      wtTestAudience,
      wtDeployEnv: LOCAL_OR_PLAYGROUND ? Constants.DEV : Constants.PROD,
      wtCountryCode: window.__sbmCountryCode || '',
      wtFromSEM,
      wtFromAffiliate,
    },
  }

  return (
    <OptimizelyProvider optimizely={optimizely} user={user}>
      {children}
    </OptimizelyProvider>
  )
}

export default OptProvider



// WEBPACK FOOTER //
// ./src/components/OptimizelyProvider/index.tsx